module.exports = __webpack_public_path__ + "static/media/preview_coupon_campaign.fc13bea3.svg";